import { navigationActions } from "@tm/insurance/navigation";
import { AnchorTag } from "@tm/static";
import { useReferrerContext } from "@tm/ui-widgets/hooks";

interface LandingHeaderBackButtonProps {
  handleBackBtn?: () => void;
  displayWhiteHeader?: boolean;
  exitWebViewOnBack?: boolean;
  showPwaHeaderBackButton?: boolean;
}

export const LandingHeaderBackButton = (
  props: LandingHeaderBackButtonProps
) => {
  const serverReferrer = useReferrerContext();

  const handleBackButton = () => {
    if (props.exitWebViewOnBack && window.mmt_android_bridge) {
      window.mmt_android_bridge.closeWebView();
    } else if (serverReferrer) {
      navigationActions.goBack();
    } else {
      history.back();
    }
  };

  const {
    handleBackBtn = handleBackButton,
    displayWhiteHeader,
    showPwaHeaderBackButton = true,
  } = props;
  return showPwaHeaderBackButton && handleBackBtn ? (
    <AnchorTag handleClick={handleBackBtn}>
      {
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z"
            fill="#4A4A4A"
          />
        </svg>
      }
    </AnchorTag>
  ) : (
    <div style={{ width: "24px", height: "24px" }}></div>
  );
};
